import React, { useState } from 'react';
import CustomTab from '@/components/UI/Tabs/CustomTab';
import GeneralSetup from './GeneralSetup';
import TeamsandLocations from './TeamsandLocations';
import PaymentSetup from './PaymentSetup';
import SectionCards from '@/components/UI/Cards/SectionCards';
import { CompanyBuildingIcon } from '@/asset/icons';

const CompanySetupForm = ({data, initialTab = 0}) => {
  // Local state to control the active tab
  const [activeTab, setActiveTab] = useState(initialTab);

  // Tab configuration for company setup
  const tabs = [
    {
      label: 'General Info',
      content: <GeneralSetup data={data} />,
    },
    {
      label: 'Teams & Locations',
      content: <TeamsandLocations />,
    },
    {
      label: 'Payments',
      content: <PaymentSetup />,
    },
  ];

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
  };

  const handleDownload = () => {
    // Add download logic here
  };

  return (
    <SectionCards
      title="Company Setup"
      subtitle="Setup your company details, structure, and payment methods"
      icon={<CompanyBuildingIcon/>}
    >
      <div className="px-6 py-4">
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}          // ✅ Controlled by parent
          onTabChange={handleTabChange}  // ✅ Notifies parent on switch
          onDownload={handleDownload}
          showDownloadButton={false}
          className="border-none"
        />
      </div>
    </SectionCards>
  );
};

export default CompanySetupForm;
